import { render, staticRenderFns } from "./Result1.vue?vue&type=template&id=5ad9b733&scoped=true"
import script from "./Result1.vue?vue&type=script&lang=js"
export * from "./Result1.vue?vue&type=script&lang=js"
import style0 from "./Result1.vue?vue&type=style&index=0&id=5ad9b733&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad9b733",
  null
  
)

export default component.exports